
















import {Component, Prop, Vue} from 'vue-property-decorator'
import {DappSocialCollection} from '@/model/collection/DappSocialCollection'
import {FilterDappSocialSchema} from '@/schema/resource/DappSocial/FilterDappSocialSchema'

@Component
export default class FilterDappSocial extends Vue {
  @Prop({type: Object, required: true}) collection!: DappSocialCollection

  schema = new FilterDappSocialSchema()

  async created() {
    await this.populateFilterOptions()
  }

  async populateFilterOptions() {
    this.collection.resource = this.schema

    const promises: Array<Promise<any>> = [
      this.collection.resource.collectionDapp.queryAsPage(),
      this.collection.resource.collectionSocialType.queryAsPage(),
    ]

    await this.$await.run('softQuery', () => Promise.all(promises))
  }

  async doFilter() {
    this.$emit('submit')
    await this.$await.run('softQuery', () => this.collection.queryAsPage())
  }
}
